// extracted by mini-css-extract-plugin
export default {"fullscreenMessage":"style_fullscreenMessage__Kaf7W","backdrop":"style_backdrop__A2np1","login":"style_login__9qz5D","icon":"style_icon__4DsDh"};